import { Modal, Tabs } from "antd";
import React from "react";
import styles from "./index.module.less";

const Agreement = (props) => {
  const { open, onCancel, agreementList, activeKey, onChange } = props;
  return (
    <Modal title="客户须知" centered open={open} footer={null} onCancel={onCancel}>
      <div className={styles.agreeContent}>
        <Tabs size="small" activeKey={activeKey}items={agreementList} onChange={onChange} />
      </div>
    </Modal>
  );
};

export default Agreement;
